import * as React from "react";
import type { SVGProps } from "react";
const SvgBluetooth02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 8.124 18 16.4l-6.4 5.2V2.4L18 7.6 6 15.876"
    />
  </svg>
);
export default SvgBluetooth02;
